const Template = `
<div class="right-info-modems">
  <div class="date-range">
    <button class="input-dark form-control" v-for="date in dateRanges" v-bind:class="{ range_active: periodDays == date.value }" @click="changeRange(date.value)">{{date.label}}</button>
    
    <input class="input-dark form-control" type="date" v-model="startDate" @change="onDateRangeChange">
    <input class="input-dark form-control" type="date" v-model="endDate" @change="onDateRangeChange">
  </div>
  <div class="modem-info-logs">
    <ag-grid-vue
      class="ag-theme-balham-dark ag-theme-rtube"
      :columnDefs="fields"
      :rowData="dataLogs"
      pagination="true"
      :paginationPageSize="perPage">
    </ag-grid-vue>
  </div>
</div>`;

export { Template };



// WEBPACK FOOTER //
// ./src/app/js/components/page2_modems/info_window/template.js